import { helpers } from '@vuelidate/validators'

import CheckboxFieldPlugin from '@/features/settingsManagement/fieldManagement/edit/plugin/checkboxFieldPlugin/CheckboxFieldPlugin.vue'
import CheckboxFieldPluginValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/checkboxFieldPlugin/CheckboxFieldPluginValueRenderer.vue'
import { normalizeFieldExtraData } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'
import { mergeDeep } from '@/features/utils/object.utils.js'

const defaultData = {
  trueValue: 1,
  falseValue: 0,
}

export const checkboxFieldPlugin = {
  type: 'checkbox',
  component: CheckboxFieldPlugin,
  valueRenderer: CheckboxFieldPluginValueRenderer,
  defaultExtraData: defaultData,
  getValidations({ props }) {
    const field = props.field
    const extraData = mergeDeep(defaultData, normalizeFieldExtraData(field.extraData))
    const rules = {}
    const key = field.key

    const isRequired =
      typeof props.externalRequired === 'boolean' ? props.externalRequired : field.isCompulsory
    if (isRequired) {
      const message = `${key} is required`
      rules.required = helpers.withMessage(message, value => {
        return value === extraData.trueValue
      })
    }

    return rules
  },
}
